import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ShoppingCartIcon } from 'lucide-react';
const proofs = [{
  name: 'María',
  city: 'Buenos Aires'
}, {
  name: 'Luciana',
  city: 'Córdoba'
}, {
  name: 'Sofía',
  city: 'Rosario'
}, {
  name: 'Camila',
  city: 'Mendoza'
}, {
  name: 'Valentina',
  city: 'La Plata'
}, {
  name: 'Florencia',
  city: 'Tucumán'
}, {
  name: 'Carolina',
  city: 'Mar del Plata'
}, {
  name: 'Daniela',
  city: 'Salta'
}, {
  name: 'Julieta',
  city: 'Santa Fe'
}, {
  name: 'Agustina',
  city: 'Neuquén'
}];
export function SocialProofPopup() {
  const [visible, setVisible] = useState(false);
  const [current, setCurrent] = useState(0);
  useEffect(() => {
    const showPopup = () => {
      setCurrent(Math.floor(Math.random() * proofs.length));
      setVisible(true);
      setTimeout(() => {
        setVisible(false);
      }, 4000);
    };
    const initialDelay = setTimeout(() => {
      showPopup();
      const interval = setInterval(() => {
        showPopup();
      }, Math.random() * 10000 + 15000); // 15-25 seconds
      return () => clearInterval(interval);
    }, 8000);
    return () => {
      clearTimeout(initialDelay);
    };
  }, []);
  const proof = proofs[current];
  return <AnimatePresence data-id="element-326">
      {visible && <motion.div initial={{
      x: -100,
      opacity: 0
    }} animate={{
      x: 0,
      opacity: 1
    }} exit={{
      x: -100,
      opacity: 0
    }} transition={{
      type: 'spring',
      stiffness: 300,
      damping: 30
    }} className="fixed bottom-4 left-4 z-50 bg-white rounded-xl shadow-2xl border border-gray-200 px-4 py-3 max-w-[320px] flex items-center gap-3" data-id="element-327">
          <div className="bg-green-100 rounded-full p-2 flex-shrink-0" data-id="element-328">
            <ShoppingCartIcon className="w-5 h-5 text-green-600" data-id="element-329" />
          </div>
          <div data-id="element-330">
            <p className="text-sm font-semibold text-gray-900" data-id="element-331">
              {proof.name} de {proof.city}
            </p>
            <p className="text-xs text-gray-600" data-id="element-332">
              acaba de comprar el MegaPack
            </p>
            <p className="text-xs text-green-600 font-medium mt-0.5" data-id="element-333">
              Hace unos momentos
            </p>
          </div>
        </motion.div>}
    </AnimatePresence>;
}